import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatButtonModule } from '@angular/material/button';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatMenuModule } from '@angular/material/menu';
import { MatSelectModule } from '@angular/material/select';
import { FoundationLocaleSelectComponent } from './locale-select.component';

@NgModule({
    declarations: [ FoundationLocaleSelectComponent ],
    imports: [
        CommonModule,
        MatFormFieldModule,
        MatInputModule,
        MatAutocompleteModule,
        MatSelectModule,
        MatIconModule,
        MatMenuModule,
        MatButtonModule
    ],
    exports: [ FoundationLocaleSelectComponent ]
})
export class FoundationLocaleSelectModule {}
